export default {
    data: function () {
        return {
            animate: {
                slideInRight: {
                    classes: 'slideInRight',
                    duration: 1000,
                    delay: 500,
                },
                slideInUp: {
                    classes: 'slideInUp',
                    duration: 1000,
                    delay: 500,
                },
                slideOutUp: {
                    classes: 'slideOutUp',
                    duration: 1000,
                    delay: 500,
                },
                slideInLeft: {
                    classes: 'slideInLeft',
                    duration: 1000,
                    delay: 500,
                },
                fadeInUp: {
                    classes: 'fadeInUp',
                    duration: 500,
                    delay: 500,
                },
                fadeIn: {
                    classes: 'fadeIn',
                    duration: 500,
                    delay: 500,
                },
                fadeOut: {
                    classes: 'fadeOut',
                    duration: 1000,
                    delay: 500,
                },
            },
            dateranges: '',
            imgObj: {
                src: 'http://localhost/vgps-frontend/public/images/loader-gif.gif',
                error: 'http://localhost/vgps-frontend/public/images/loader-gif.gif',
                loading: 'http://localhost/vgps-frontend/public/images/loader-gif.gif'
            },
            imgUrl: 'http://localhost/vgps-frontend/public/images/loader-gif.gif' // String
        };
    },
    mounted: function () {

        // var vm = this;
        // var dates = $('#event-search-dateranges').parent().parent().data('dateranges');
        // dates = (typeof dates != 'undefined' &&  dates != '')?dates.split('~'):'';
        // $('#event-search-dateranges').val(dates);
        // vm.dateranges = dates

    },
    updated: function () {

    },
    created: function () {
        //console.log('Printing from the Mixin');
    },
    methods: {
        openNav: function () {
            document.getElementById("mySidenav").style.width = "100%";
        },
        closeNav: function () {
            document.getElementById("mySidenav").style.width = "0";
        },
        invoiceStatus(status){
            var class_n='info';
        switch(status){
            case 'paid':
                class_n="success";
            break;
            case 'late':
                class_n="danger";
            break;
            default:
                class_n="info";
            break;
        }

        return "<span class='badge badge-"+class_n+"'><strong>"+status+"</strong></span>";
        },
        getCurrentDate(){
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();
            today = mm + '/' + dd + '/' + yyyy;
            return today;
        },
        notEmpty(target){
            if(target !=null && target!="" && target!='' && target!='null' && target!='NULL' && typeof target != "undefined"){
                return true;
            }
            return false;
        },
        copyToClipboard(text) {
	    if (window.clipboardData && window.clipboardData.setData) {
		// Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
		return window.clipboardData.setData("Text", text);

	    }
	    else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
		var textarea = document.createElement("textarea");
		textarea.textContent = text;
		textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
		document.body.appendChild(textarea);
		textarea.select();
		try {
		    return document.execCommand("copy");  // Security exception may be thrown by some browsers.
		}
		catch (ex) {
		    console.warn("Copy to clipboard failed.", ex);
		    return false;
		}
		finally {
		    document.body.removeChild(textarea);
		}
	    }
	},
        getDateByDT(dt){ //dt is string
            if(dt==null || dt=='' || dt==""){
                return 'N/A';
            }
            else{
                var d = new Date(dt);
                var dd = String(d.getDate()).padStart(2, '0');
                var mm = String(d.getMonth() + 1).padStart(2, '0'); //January is 0!
                var yyyy = d.getFullYear();
                return mm + '/' + dd + '/' + yyyy;
            }
        },

        hasDuplicateEmail(data){
            var setValue = new Set();
            var hasDuplicates = false;
            data.forEach(function(item) {
                if (setValue.has(item.email)) {
                  hasDuplicates = true;
                  return;
                }
                setValue.add(item.email);
              });
            return hasDuplicates;
        }

    },
    filters: {
        removeDashes: function(str){
            var newStr = str.replace(/-/g, " ");
            return newStr
        },
        assetPath: function (img) {
            var path = window.axios.defaults.baseURL + '/images/' + img;
            return path;
        },
        checkObj: function (obj) {
            return (obj == '') ? false : true
        },
        url: function (path) {
            var path = window.axios.defaults.baseURL + '/' + path;
            return path;
        },
        defaultValue(value){
            return ((value==null || value=='' || value=="")? 'N/A': value);

        },
        notFoundValue(value){
            return ((value==null || value=='' || value=="")? 'Not Found': value);
        },
        getDateByDT(dt){ //dt is string
            if(dt==null || dt=='' || dt==""){
                return 'N/A';
            }
            else{
            var d = new Date(dt);
            var dd = String(d.getDate()).padStart(2, '0');
            var mm = String(d.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = d.getFullYear();
            return mm + '/' + dd + '/' + yyyy;
            }
        },
        printStatus(status){

            switch(status){
                case 'under_testing':
                    return 'Under Testing';
                break;
                case 'tested':
                    return 'Testing Completed';
                break;
                case 'need_to_repair':
                    return 'Need to repair';
                break;
                case 'ready_for_distributed':
                    return 'Ready for Distribution';
                break;
                case 'Pending':
                    return 'Pending';
                break;
                case 'sold':
                    return 'Sold';
                break;
                default:
                    return 'N/A';
            }

        }
    }
}
